import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowCircularFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowCircularFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M5 12c0-1.9.77-3.62 2-4.88V11h3V2.5H1.5v3h2.92A9.914 9.914 0 0 0 2 12c0 5.18 3.96 9.45 9 9.95v-3.03c-3.39-.49-6-3.4-6-6.92ZM19.58 18.5A9.914 9.914 0 0 0 22 12c0-5.18-3.95-9.45-9-9.95v3.03c3.39.49 6 3.4 6 6.92 0 1.9-.77 3.62-2 4.88V13h-3v8.5h8.5v-3h-2.92Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default ArrowCircularFilled;